import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-auth-redirect',
  template: ''
})
export class AuthRedirectComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private auth: AuthService
  ) { }

  ngOnInit(): void {
    const mode = this.route.snapshot.data['mode'];

    if (mode === 'signup') {
      this.auth.loginWithRedirect({
        authorizationParams: { screen_hint: 'signup' }
      });
    } else {
      this.auth.loginWithRedirect();
    }
  }
}
